import {
  SubHeadingTypography,
  ButtonGroup,
  StyledMenuButton,
  ListOfEnergySourceBox,
  StyledLabel,
  StyledBox,
  ButtonContainer,
  HeaderBox,
} from './style'
import { useTranslation } from 'react-i18next'
import CheckIcon from '@mui/icons-material/Check'
import networkImg from '../EnergyMix/Assets/netzstrom_oli.svg'
import PriceBarGraph from './PriceBarGraph'
import {
  WindIconWithoutBackground,
  HydroEnergyIcon,
  SolarEnergyIcon,
  BioMassIcon,
} from '../../components/icons/myIcons'
import PriceTable from './PriceTable'
import Feedback from '../../components/Feedback'
import { Typography } from '@mui/material'
import React from 'react'

const Divider = ({ style }) => {
  return <hr style={{ ...defaultStyle, ...style }} />
}

const defaultStyle = {
  border: 0,
  height: '1px',
  background: '#333',
  margin: '20px 0',
}

/**
 * This component holds the price bar graph and also the table for showing the prices overview. That are shown on Aschlage screen.
 *
 * @param {Object} props - Component props
 * @param {boolean} props.error - Error state
 * @param {Function} props.onCloseFeedback - Function to close error feedback
 * @returns {React.ReactNode} - it returns the bar graph i.e. PriceBarGraph and the table i.e. PriceTable.
 */
const DiscountOverview = ({
  data,
  setEnergyRole,
  energyRole,
  error,
  onCloseFeedback,
}) => {
  const { t } = useTranslation()

  const handleButtonClick = (buttonType) => {
    setEnergyRole(buttonType)
  }

  return (
    <>
      <div style={{ padding: '40px' }}></div>
      <HeaderBox>
        <SubHeadingTypography variant="h1">
          {t('LBLAbschlagUberblick')}
        </SubHeadingTypography>
      </HeaderBox>
      <Divider style={{ background: 'red', height: '10px' }} />
      <StyledBox>
        <ButtonContainer>
          <ButtonGroup>
            <StyledMenuButton
              variant={energyRole === 'PRODUCER' ? 'contained' : 'outlined'}
              className={energyRole === 'PRODUCER' ? 'selected' : ''}
              onClick={() => handleButtonClick('PRODUCER')}
            >
              {energyRole === 'PRODUCER' && <CheckIcon />} {t('LBLProducer')}
            </StyledMenuButton>
            <StyledMenuButton
              variant={energyRole === 'CONSUMER' ? 'contained' : 'outlined'}
              className={energyRole === 'CONSUMER' ? 'selected' : ''}
              onClick={() => handleButtonClick('CONSUMER')}
            >
              {energyRole === 'CONSUMER' && <CheckIcon />} {t('LBLConsumer')}
            </StyledMenuButton>
          </ButtonGroup>
        </ButtonContainer>
        <ListOfEnergySourceBox>
          <StyledLabel variant="h8">
            <BioMassIcon /> Biomasse
          </StyledLabel>
          <StyledLabel variant="h8">
            <SolarEnergyIcon /> Solar
          </StyledLabel>
          <StyledLabel variant="h8">
            <HydroEnergyIcon /> Wasserkraft
          </StyledLabel>
          <StyledLabel variant="h8">
            <WindIconWithoutBackground /> Windstrom
          </StyledLabel>
          {energyRole !== 'PRODUCER' && (
            <StyledLabel>
              <img src={networkImg} alt="Fossil" /> Netzstrom
            </StyledLabel>
          )}
        </ListOfEnergySourceBox>
      </StyledBox>
      <PriceBarGraph priceData={data} selectedType={energyRole} />
      <PriceTable priceData={data} selectedType={energyRole} />

      {/* Error messages */}
      <Feedback
        open={Boolean(error)}
        title={t('LBLDataInfo')}
        message={
          <>
            <Typography align="center">{t('LBLDataMsg')}</Typography>
          </>
        }
        handleClose={onCloseFeedback}
      />
    </>
  )
}

export default DiscountOverview
